// Will be replaced during production builds - see prepare.sh
export const BuildVersion = "cf29e4d";
